module.exports = __webpack_public_path__ + "img/9.9e0c3c50.jpg";